import { useState, useEffect, useRef } from "react";
import { Container, div, Row, Col, Button, Table } from "react-bootstrap";
import {
  ADD_CC_EMAILS,
  GET_CC_EMAILS,
  // CUSTOMERID,
  // TOKEN,
  GetCustomerId,
  GetToken,
  BASEURL,
} from "../../CONSTANTS";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../Components/Loader";
import { useScreenSize, useCustomScreen } from "../../Components/Utils";

export default function DeliveryPreferences() {
  const [getEndpoint, setGetEndpoint] = useState("search");
  const token = localStorage.getItem("token");
  const [email, setEmail] = useState("");
  const [isAlwaysCC, setIsAlwaysCC] = useState(false);
  const [listOfEMails, setListOfEmails] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [changedMails, setChangedMaild] = useState([]);
  const [loading, setLoading] = useState(false);

  const [loadingIndex, setLoadingIndex] = useState(null);
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  const navigate = useNavigate();
  // const { ccEMailsList , error, loading } = useFetch(
  //   getEndpoint ? `${GET_CC_EMAILS}` : null,
  //   {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': `Bearer ${token}` // Add your token here
  //     }
  //   },
  //   [getEndpoint] // Dependencies to trigger fetch
  // );
  useEffect(() => {
    loadCCEmails();
  }, []);

  // useEffect(() => {
  //   console.log(isLoading);
  // }, [isLoading]);
  // useEffect(() => {
  //   console.log(listOfEMails);
  // }, [listOfEMails]);

  const loadCCEmails = async () => {
    setIsLoading(true);
    try {
      // setLoading(true);
      const res = await fetch(GET_CC_EMAILS(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${GetToken()}`, // Add your token here
        },
      });
      if (res.ok) {
        const result = await res.json();
        Array.isArray(result)
          ? setListOfEmails([...result])
          : setListOfEmails([]);
      }
    } catch (e) {
      navigate("/login");
      setIsLoading(false);
    }
  };

  const saveEmailHandler = async () => {
    if (!email) return;
    const data = {
      customerId: `${GetCustomerId()}`,
      ccEmails: [
        {
          email: `${email}`,
          alwaysCc: Boolean(isAlwaysCC),
        },
      ],
    };
    try {
      setLoading(true);
      const res = await fetch(`${ADD_CC_EMAILS}`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${GetToken()}`, // Add your token here
        },
      });

      if (res.ok) {
        const result = await res.json();

        setIsAlwaysCC(false);
        setEmail("");
        Array.isArray(result) && setListOfEmails([...result]);
        loadCCEmails();

        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  const emailChangeHandler = (e) => {
    setEmail(e.target.value);
  };

  const changeIsAlwaysCCHandler = (e) => {
    setIsAlwaysCC(e.target.value);
  };

  // const handleDelete = (mail,mailInd) => {
  //   setLoadingIndex(mailInd)
  //   deleteSelectedItem(mail,mailInd);
  // }

  const deleteSelectedItem = async (mail, mailInd) => {
    const tempList = [...listOfEMails];

    if (Array.isArray(tempList) && tempList.length) {
      tempList.length >= mailInd && setSelectedItem(tempList[mailInd]);
    }
    try {
      setLoading(true);
      let res = await fetch(
        `${BASEURL}customers/${mail?.customerEmailId}/cc-emails`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${GetToken()}`, // Add your token here
          },
        }
      );
      if (res) {
        setListOfEmails((prevEmails) =>
          prevEmails.filter((_, index) => index !== mailInd)
        );
      }
    } catch (e) {
      console.log(e);
      navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  const changeTheAllwaysCCStatus = async () => {
    const data = {
      customerEmailId: 144,
      email: "padmavathi.elluru21@gmail.com",
      alwaysCc: true,
    };
    try {
      setLoading(true);
      const res = await fetch(
        `${BASEURL}customers/${GetCustomerId()}/cc-emails`,
        {
          method: "PUT",
          body: JSON.stringify(data),
        }
      );
    } catch (e) {
      navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateAlwaysCC = async (e, ind) => {
    let tempList = listOfEMails.length > 0 ? [...listOfEMails] : [];
    const currentMail = tempList[ind];

    setListOfEmails([...tempList]);
    if (!currentMail) return;

    const updatedCc = !currentMail.alwaysCc;
    const payload = {
      customerEmailId: currentMail.customerEmailId,
      email: currentMail.email,
      alwaysCc: updatedCc,
    };
    try {
      const response = await fetch(
        `${BASEURL}customers/${currentMail.customerEmailId}/cc-emails`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${GetToken()}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        loadCCEmails();
        tempList[ind] = { ...currentMail, alwaysCc: updatedCc };
        setListOfEmails(tempList);
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      {loading ? (
        <Container
          style={{ height: "100vh" }}
          className="w-100% d-flex justify-content-center align-items-center"
        >
          <Spinner animation="border" role="status"></Spinner>
        </Container>
      ) : (
        <Container className="pb-5 p-3">
          <h5
            style={{
              backgroundColor: "lightblue",
              padding: "1em 0",
              width: "100%",
              fontSize: is4kScreen
                ? "2rem"
                : isXxlScreen
                ? "1.4rem"
                : isXlScreen
                ? "1.2rem"
                : isIpadProPortrait
                ? "1.95rem"
                : isLargeScreen
                ? ""
                : isMediumScreen
                ? "1.7rem"
                : "",
            }}
          >
            <b className="text-center p-3">Delivery Preferences</b>
          </h5>
          <div className="pt-3">
            <h6
              style={{
                fontSize: is4kScreen
                  ? "1.6rem"
                  : isIpadProPortrait
                  ? "1.6rem"
                  : isMediumScreen
                  ? "1.3rem"
                  : "",
              }}
            >
              <b>Add Additional Email Address to Delivered Reports</b>
            </h6>
          </div>
          <div className="pt-3">
            <Row className="mb-3">
              <Col xs={12} sm={4} md={4} className="text-center">
                <label
                  htmlFor="new-email"
                  style={{
                    fontSize: is4kScreen
                      ? "1.7rem"
                      : isXxlScreen
                      ? "1.2rem"
                      : isMediumScreen
                      ? "1.3rem"
                      : isIpadProPortrait
                      ? "1.9rem"
                      : "",
                  }}
                >
                  New Email Address:
                </label>
              </Col>
              <Col
                xs={12}
                sm={8}
                md={6}
                className="input-col align-items-center credits-purchase"
              >
                <input
                  type="email"
                  style={{
                    width: "70%",
                    fontSize: isMediumScreen
                      ? "1.3rem"
                      : isIpadProPortrait
                      ? "1.5rem"
                      : "",
                  }}
                  className="form-control"
                  value={email}
                  onChange={(e) => emailChangeHandler(e)}
                  required
                />
              </Col>
            </Row>
            <Row className="mb-3 justify-content-center align-items-center">
              <Col
                xs={12}
                sm={4}
                md={3}
                className="d-flex justify-content-center align-items-center gap-2"
              >
                <input
                  type="checkbox"
                  value={isAlwaysCC}
                  checked={isAlwaysCC}
                  onChange={(e) => changeIsAlwaysCCHandler(e)}
                  style={{
                    width: is4kScreen
                      ? "25px"
                      : isIpadProPortrait
                      ? "25px"
                      : isMediumScreen
                      ? "20px"
                      : "",
                    height: is4kScreen
                      ? "25px"
                      : isIpadProPortrait
                      ? "25px"
                      : isMediumScreen
                      ? "20px"
                      : "",
                  }}
                />
                <span
                  className=""
                  style={{
                    fontSize: is4kScreen
                      ? "1.7rem"
                      : isXxlScreen
                      ? "1.1rem"
                      : isIpadProPortrait
                      ? "1.7rem"
                      : isMediumScreen
                      ? "1.3rem"
                      : "",
                  }}
                >
                  Always CC
                </span>
              </Col>
            </Row>
            <br></br>
            <Row>
              <Col
                md={12}
                className="d-flex justify-content-center align-items-center"
              >
                <Button
                  className="login-btns btn mb-3 px-4"
                  style={{
                    fontSize: is4kScreen
                      ? "1.7rem"
                      : isXxlScreen
                      ? "1.1rem"
                      : isIpadProPortrait
                      ? "1.7rem"
                      : isMediumScreen
                      ? "1.3rem"
                      : "",
                  }}
                  type="submit"
                  onClick={() => saveEmailHandler()}
                >
                  Save
                </Button>
              </Col>
            </Row>
          </div>
          <br></br>
          <br></br>
          <h6
            style={{
              fontSize: is4kScreen
                ? "1.6rem"
                : isIpadProPortrait
                ? "1.6rem"
                : isMediumScreen
                ? "1.3rem"
                : "",
            }}
          >
            <b>Delivery Emails</b>
          </h6>
          <div>
            <Table className="w-100">
              <thead style={{ backgroundColor: "lightgray" }} className="p-1">
                <tr style={{ backgroundColor: "lightgray" }}>
                  <th
                    style={{
                      backgroundColor: "lightgray",
                      fontSize: is4kScreen
                        ? "1.7rem"
                        : isXxlScreen
                        ? "1.1rem"
                        : isIpadProPortrait
                        ? "1.5rem"
                        : isMediumScreen
                        ? "1.2rem"
                        : "",
                    }}
                    className="p-1"
                  >
                    CC Email
                  </th>
                  <th
                    style={{
                      backgroundColor: "lightgray",
                      fontSize: is4kScreen
                        ? "1.7rem"
                        : isXxlScreen
                        ? "1.1rem"
                        : isIpadProPortrait
                        ? "1.5rem"
                        : isMediumScreen
                        ? "1.2rem"
                        : "",
                    }}
                    className="text-center p-1"
                  >
                    Always CC
                  </th>
                  <th
                    style={{
                      backgroundColor: "lightgray",
                      fontSize: is4kScreen
                        ? "1.7rem"
                        : isXxlScreen
                        ? "1.1rem"
                        : isIpadProPortrait
                        ? "1.5rem"
                        : isMediumScreen
                        ? "1.2rem"
                        : "",
                    }}
                    className="text-center p-1"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(listOfEMails) && listOfEMails.length ? (
                  listOfEMails.map((mail, mailInx) => (
                    // <Container
                    //   fluid
                    //   style={{
                    //     display: "flex",
                    //     justifyContent: "center",
                    //     alignItems: "center",
                    //   }}
                    // >
                    //   <Row className="w-100 d-flex justify-content-center align-items-center mb-2">
                    //     <Col xs={4} sm={4} className=" p-2 text-center">
                    //       <p style={{ fontSize: is4kScreen ? "1.7rem" : "" }}>
                    //         {mail?.email ?? "-"}
                    //       </p>
                    //     </Col>
                    //     <Col xs={4} sm={4} className=" p-2 text-center">
                    //       <input
                    //         type="checkbox"
                    //         value={mail?.alwaysCc}
                    //         checked={mail?.alwaysCc === true}
                    //         onChange={(e) => handleUpdateAlwaysCC(e, mailInx)}
                    //         style={{
                    //           width: is4kScreen ? "25px" : "",
                    //           height: is4kScreen ? "25px" : "",
                    //         }}
                    //       />
                    //     </Col>
                    //     <Col xs={4} sm={4} className="p-2 text-center">
                    //       <div
                    //         style={{
                    //           color: "red",
                    //           textDecoration: "underline",
                    //           cursor: "pointer",
                    //         }}
                    //         onClick={() => deleteSelectedItem(mail, mailInx)}
                    //       >
                    //         <p style={{ fontSize: is4kScreen ? "1.7rem" : "" }}>
                    //           Delete
                    //         </p>
                    //       </div>
                    //     </Col>
                    //   </Row>
                    // </Container>
                    <tr style={{}}>
                      <td
                        className="p-3"
                        style={{
                          fontSize: is4kScreen
                            ? "1.7rem"
                            : isXxlScreen
                            ? "1.1rem"
                            : isIpadProPortrait
                            ? "1.5rem"
                            : isMediumScreen
                            ? "1.2rem"
                            : "",
                        }}
                      >
                        {mail?.email ?? "-"}
                      </td>
                      <td className="p-4">
                        <div className="d-flex flex-column justify-content-center align-items-center">
                          {" "}
                          <input
                            type="checkbox"
                            checked={!!mail?.alwaysCc}
                            onChange={(e) => handleUpdateAlwaysCC(e, mailInx)}
                            style={{
                              width: is4kScreen
                                ? "30px"
                                : isXxlScreen
                                ? "17px"
                                : isIpadProPortrait
                                ? "25px"
                                : "",
                              height: is4kScreen
                                ? "30px"
                                : isXxlScreen
                                ? "17px"
                                : isIpadProPortrait
                                ? "25px"
                                : "",
                              margin: "0px",
                            }}
                          />
                        </div>
                      </td>
                      <td className="p-3">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "red",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                          onClick={() => deleteSelectedItem(mail, mailInx)}
                        >
                          <p
                            style={{
                              fontSize: is4kScreen
                                ? "1.7rem"
                                : isXxlScreen
                                ? "1.1rem"
                                : isIpadProPortrait
                                ? "1.5rem"
                                : isMediumScreen
                                ? "1.2rem"
                                : "",
                              margin: "0px",
                            }}
                          >
                            Delete
                          </p>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <span style={{ fontSize: is4kScreen ? "1.7rem" : "" }}>
                    No existing mails
                  </span>
                )}
              </tbody>
            </Table>
          </div>

          {/* {Array.isArray(listOfEMails) && listOfEMails.length ? (
            listOfEMails.map((mail, mailInx) => (
              <Container
                fluid
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Row className="w-100 d-flex justify-content-center align-items-center mb-2">
                  <Col xs={4} sm={4} className=" p-2 text-center">
                    <p style={{ fontSize: is4kScreen ? "1.7rem" : "" }}>
                      {mail?.email ?? "-"}
                    </p>
                  </Col>
                  <Col xs={4} sm={4} className=" p-2 text-center">
                    <input
                      type="checkbox"
                      value={mail?.alwaysCc}
                      checked={mail?.alwaysCc === true}
                      onChange={(e) => handleUpdateAlwaysCC(e, mailInx)}
                      style={{
                        width: is4kScreen ? "25px" : "",
                        height: is4kScreen ? "25px" : "",
                      }}
                    />
                  </Col>
                  <Col xs={4} sm={4} className="p-2 text-center">
                    <div
                      style={{
                        color: "red",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={() => deleteSelectedItem(mail, mailInx)}
                    >
                      <p style={{ fontSize: is4kScreen ? "1.7rem" : "" }}>
                        Delete
                      </p>
                    </div>
                  </Col>
                </Row>
              </Container>
            ))
          ) : (
            <span style={{ fontSize: is4kScreen ? "1.7rem" : "" }}>
              No existing mails
            </span>
          )} */}
        </Container>
      )}
    </>
  );
}
